export default __webpack_public_path__ + "static/102757-2c70a8ef4a1fcaa511a3731806819cec.jpg";